(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$BOARD_SIZE = 4;
var $3d28d7f1aac198f5$var$WIN_VALUE = 2048;
function $3d28d7f1aac198f5$var$createEmptyState() {
    return Array.from({
        length: $3d28d7f1aac198f5$var$BOARD_SIZE
    }, function() {
        return Array($3d28d7f1aac198f5$var$BOARD_SIZE).fill(0);
    });
}
function $3d28d7f1aac198f5$var$cloneState(state) {
    return state.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    });
}
function $3d28d7f1aac198f5$var$transpose(state) {
    var result = $3d28d7f1aac198f5$var$createEmptyState();
    for(var row = 0; row < $3d28d7f1aac198f5$var$BOARD_SIZE; row += 1)for(var col = 0; col < $3d28d7f1aac198f5$var$BOARD_SIZE; col += 1)result[col][row] = state[row][col];
    return result;
}
function $3d28d7f1aac198f5$var$reverseRows(state) {
    return state.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
    });
}
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $3d28d7f1aac198f5$var$createEmptyState();
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = $3d28d7f1aac198f5$var$cloneState(initialState);
        this.state = $3d28d7f1aac198f5$var$cloneState(initialState);
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.makeMove("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.makeMove("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.makeMove("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.makeMove("down");
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return $3d28d7f1aac198f5$var$cloneState(this.state);
            }
        },
        {
            /**
   * @returns {string}
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status !== "idle") return;
                this.addRandomCell();
                this.addRandomCell();
                this.updateStatus();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = $3d28d7f1aac198f5$var$cloneState(this.initialState);
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "makeMove",
            value: function makeMove(direction) {
                if (this.status !== "playing") return;
                var _this_getMovedState = this.getMovedState(direction), nextState = _this_getMovedState.nextState, gainedScore = _this_getMovedState.gainedScore;
                if (this.isSameState(this.state, nextState)) return;
                this.state = nextState;
                this.score += gainedScore;
                this.addRandomCell();
                this.updateStatus();
            }
        },
        {
            key: "getMovedState",
            value: function getMovedState(direction) {
                switch(direction){
                    case "left":
                        return this.moveStateLeft(this.state);
                    case "right":
                        return this.moveStateRight(this.state);
                    case "up":
                        return this.moveStateUp(this.state);
                    case "down":
                        return this.moveStateDown(this.state);
                    default:
                        return {
                            nextState: $3d28d7f1aac198f5$var$cloneState(this.state),
                            gainedScore: 0
                        };
                }
            }
        },
        {
            key: "moveStateLeft",
            value: function moveStateLeft(state) {
                var nextState = [];
                var gainedScore = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = state[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var row = _step.value;
                        var processed = this.processLine(row);
                        nextState.push(processed.line);
                        gainedScore += processed.gainedScore;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    nextState: nextState,
                    gainedScore: gainedScore
                };
            }
        },
        {
            key: "moveStateRight",
            value: function moveStateRight(state) {
                var reversed = $3d28d7f1aac198f5$var$reverseRows(state);
                var moved = this.moveStateLeft(reversed);
                return {
                    nextState: $3d28d7f1aac198f5$var$reverseRows(moved.nextState),
                    gainedScore: moved.gainedScore
                };
            }
        },
        {
            key: "moveStateUp",
            value: function moveStateUp(state) {
                var transposed = $3d28d7f1aac198f5$var$transpose(state);
                var moved = this.moveStateLeft(transposed);
                return {
                    nextState: $3d28d7f1aac198f5$var$transpose(moved.nextState),
                    gainedScore: moved.gainedScore
                };
            }
        },
        {
            key: "moveStateDown",
            value: function moveStateDown(state) {
                var transposed = $3d28d7f1aac198f5$var$transpose(state);
                var moved = this.moveStateRight(transposed);
                return {
                    nextState: $3d28d7f1aac198f5$var$transpose(moved.nextState),
                    gainedScore: moved.gainedScore
                };
            }
        },
        {
            key: "processLine",
            value: function processLine(line) {
                var filtered = line.filter(function(value) {
                    return value !== 0;
                });
                var merged = [];
                var gainedScore = 0;
                for(var i = 0; i < filtered.length; i += 1){
                    var current = filtered[i];
                    var next = filtered[i + 1];
                    if (current === next) {
                        var mergedValue = current * 2;
                        merged.push(mergedValue);
                        gainedScore += mergedValue;
                        i += 1;
                    } else merged.push(current);
                }
                while(merged.length < $3d28d7f1aac198f5$var$BOARD_SIZE)merged.push(0);
                return {
                    line: merged,
                    gainedScore: gainedScore
                };
            }
        },
        {
            key: "addRandomCell",
            value: function addRandomCell() {
                var emptyCells = [];
                for(var rowIndex = 0; rowIndex < $3d28d7f1aac198f5$var$BOARD_SIZE; rowIndex += 1){
                    for(var colIndex = 0; colIndex < $3d28d7f1aac198f5$var$BOARD_SIZE; colIndex += 1)if (this.state[rowIndex][colIndex] === 0) emptyCells.push([
                        rowIndex,
                        colIndex
                    ]);
                }
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), targetRow = _emptyCells_randomIndex[0], targetCol = _emptyCells_randomIndex[1];
                this.state[targetRow][targetCol] = Math.random() < 0.1 ? 4 : 2;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.hasWinningCell()) {
                    this.status = "win";
                    return;
                }
                if (this.hasAvailableMoves()) {
                    this.status = "playing";
                    return;
                }
                this.status = "lose";
            }
        },
        {
            key: "hasWinningCell",
            value: function hasWinningCell() {
                return this.state.some(function(row) {
                    return row.some(function(cell) {
                        return cell >= $3d28d7f1aac198f5$var$WIN_VALUE;
                    });
                });
            }
        },
        {
            key: "hasAvailableMoves",
            value: function hasAvailableMoves() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$BOARD_SIZE; row += 1)for(var col = 0; col < $3d28d7f1aac198f5$var$BOARD_SIZE; col += 1){
                    var current = this.state[row][col];
                    if (current === 0) return true;
                    var right = col < $3d28d7f1aac198f5$var$BOARD_SIZE - 1 ? this.state[row][col + 1] : null;
                    var down = row < $3d28d7f1aac198f5$var$BOARD_SIZE - 1 ? this.state[row + 1][col] : null;
                    if (current === right || current === down) return true;
                }
                return false;
            }
        },
        {
            key: "isSameState",
            value: function isSameState(firstState, secondState) {
                for(var row = 0; row < $3d28d7f1aac198f5$var$BOARD_SIZE; row += 1)for(var col = 0; col < $3d28d7f1aac198f5$var$BOARD_SIZE; col += 1){
                    if (firstState[row][col] !== secondState[row][col]) return false;
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
function $197cd56b15c33885$var$renderBoard() {
    var state = $197cd56b15c33885$var$game.getState();
    state.flat().forEach(function(value, index) {
        var cell = $197cd56b15c33885$var$cells[index];
        cell.className = "field-cell";
        cell.textContent = "";
        if (value !== 0) {
            cell.textContent = value;
            cell.classList.add("field-cell--".concat(value));
        }
    });
}
function $197cd56b15c33885$var$renderScore() {
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$renderMessages() {
    $197cd56b15c33885$var$startMessage.classList.add("hidden");
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    switch($197cd56b15c33885$var$game.getStatus()){
        case "idle":
            $197cd56b15c33885$var$startMessage.classList.remove("hidden");
            break;
        case "win":
            $197cd56b15c33885$var$winMessage.classList.remove("hidden");
            break;
        case "lose":
            $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
            break;
        default:
            break;
    }
}
function $197cd56b15c33885$var$renderButton() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$button.className = "button start";
    } else {
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.className = "button restart";
    }
}
function $197cd56b15c33885$var$renderGame() {
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$renderScore();
    $197cd56b15c33885$var$renderMessages();
    $197cd56b15c33885$var$renderButton();
}
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$renderGame();
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            e.preventDefault();
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            e.preventDefault();
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            e.preventDefault();
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            e.preventDefault();
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderGame();
});
$197cd56b15c33885$var$renderGame();

})();
//# sourceMappingURL=index.860674a7.js.map
